import { Suspense } from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Login from './pages/login/page';
import { routes } from './config';

function App() {
  const indicatorSize = 80;

  return (
    <HashRouter>
      <div className='w-full'>
        <Suspense fallback={<div />}>
          <Routes>
            <Route index Component={Dashboard} />
            <Route path={'/login'} Component={Login} />
            {routes?.map((item, index) => (
              <Route key={index} path={item?.path} Component={item?.component} />
            ))}
          </Routes>
        </Suspense>
      </div>
    </HashRouter>
  );
}

export default App;
